/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { ActionTree } from 'vuex';
import * as types from '@/store/types';
import { handleErrorMessage, handleInfoMessage } from '@/store/handleCatchError';
import { logging } from '@/scripts/debugger';
import { OK, SERVICES } from '@/middlewares/httpClient';
import { inviteNewUser } from './apis';
import { RootState } from '../models';
import { Invititation } from './models';

const log = (message: string) => {
  logging('VUEX/flow/actions', message);
};

const service : string = SERVICES.get('userservice');

export const actions: ActionTree<Invititation, RootState> = {
  async [types.INVITE_NEW_USER]({ commit, dispatch }, email): Promise<any> {
    log('INVITE_NEW_USER is called');

    await inviteNewUser(email)
      .then(({ status, data }) => {
        if (status && status === OK) {
          const invitation: Invititation[] = data;
          commit(types.MUTATE_INVITED_USER, invitation[0]);
        }
      })
      .catch((err) => handleErrorMessage(err, dispatch, service));
  },

};
